import { render, staticRenderFns } from "./_MediaGroupArchiveWrapper.vue?vue&type=template&id=578cdaea&scoped=true&"
import script from "./_MediaGroupArchiveWrapper.vue?vue&type=script&lang=js&"
export * from "./_MediaGroupArchiveWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578cdaea",
  null
  
)

export default component.exports